export const GET_DASHBOARD_METRICS = 'GET_DASHBOARD_METRICS';

export const UPDATE_DASHBOARD_METRICS_TIMESTAMP = 'UPDATE_DASHBOARD_METRICS_TIMESTAMP';

export const UPDATE_DASHBOARD_TIMER = 'UPDATE_DASHBOARD_TIMER';
